/** SectionHeader.jsx - a Reporting section's title, subtitle and right-hand actions. */
import { Explainer } from '../../components/ui/Explainer';
import { FILTER_OPTIONS } from './chartFilters';

/* ===== CHART FILTER COMPONENT ===== */
const CF_SELECT = {
  padding: '5px 10px',
  borderRadius: 6,
  border: '1px solid #E0E0E0',
  fontSize: 10,
  fontFamily: 'Montserrat',
  outline: 'none',
  cursor: 'pointer',
  background: '#fff',
  color: '#333',
  fontWeight: 600,
};
const CF_DATE = { padding: '4px 8px', borderRadius: 6, border: '1px solid #E0E0E0', fontSize: 10, fontFamily: 'Montserrat' };
const CF_APPLY = {
  padding: '4px 10px',
  borderRadius: 6,
  fontSize: 10,
  fontWeight: 700,
  background: '#1B5E20',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};

function ChartFilter({ value, onChange, showCustom, customFrom, customTo, onCustomFromChange, onCustomToChange, onApplyCustom }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={CF_SELECT}>
        {FILTER_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {showCustom && (
        <>
          <input type="date" value={customFrom || ''} onChange={(e) => onCustomFromChange(e.target.value)} style={CF_DATE} />
          <span style={{ fontSize: 9, color: '#5A5A5A' }}>to</span>
          <input type="date" value={customTo || ''} onChange={(e) => onCustomToChange(e.target.value)} style={CF_DATE} />
          <button onClick={onApplyCustom} style={CF_APPLY}>
            Apply
          </button>
        </>
      )}
    </div>
  );
}

export function SectionHeader({ title, subtitle, right, explain }) {
  return (
    <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <div>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0D0D0D', display: 'inline-flex', alignItems: 'center' }}>
          {title}
          {explain && (
            <Explainer title={explain.title || title} formula={explain.formula} align="left">
              {explain.body}
            </Explainer>
          )}
        </div>
        {subtitle && <div style={{ fontSize: 10.5, color: '#5A5A5A', marginTop: 2 }}>{subtitle}</div>}
      </div>
      {right && <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{right}</div>}
    </div>
  );
}
